import React, { useRef } from 'react'
import styled from 'styled-components'
import { IconBin } from '../../../constants/icons'
import Colors from '../../../constants/Colors'
import { NOT_FOUND_LOTTERY_ID } from '../constants'
import { handleEnterKey } from '../../../helpers/checkEnter'

const NotFoundLotteryID = ({ lotteries, notFoundLotteryIds, setLotteries, handleClickRemoveSomeLottery }) => {
  const inputRefs = useRef([])

  const getInputLotteryId = (indexInput, e) => {
    inputRefs.current[indexInput].value = e.target.value.replace(/[^0-9-]/g, '')
  }

  const handleAddLotteryIdOnInput = (lottoIndex, inputIndex) => {
    let newLotteries = [...lotteries]
    newLotteries[lottoIndex].lotteryId = inputRefs.current[inputIndex].value
    inputRefs.current[inputIndex].value = ''
    
    setLotteries(newLotteries)
  }

  const handleClickRemoveAllNotFoundLottery = () => {
    const newLotteries = lotteries.filter((lotto) => lotto.lotteryId !== NOT_FOUND_LOTTERY_ID)
    setLotteries(newLotteries)
  }

  return (
    <NotFoundLotteryIDContent>
      <div className="lottery-header">
        <div className="lottery-title">ไม่สามารถอ่านข้อมูลจากลอตเตอรี่ได้ ทั้งหมด {notFoundLotteryIds.length} ใบ</div>
        <button onClick={handleClickRemoveAllNotFoundLottery} className="remove-lottery-ids">ลบลอตเตอรี่ที่ไม่มีตัวเลขทั้งหมด</button>
      </div>
      <div className="lottery-content">
        {notFoundLotteryIds.map((lotto, inputIndex) => {
          return (
            <div className="lottery-box" key={lotto.url}>
              <div onClick={() => handleClickRemoveSomeLottery(lotto.index)} className="lottery-overlay-color">
                <span className="lottery-icon-box">
                  <IconBin fill={Colors.WHITE} />
                </span>
                <div className="lottery-overlay"></div>
                <img src={lotto.url} alt="img lottery" className="lottery-image" />
              </div>
              <input
                type="text"
                maxLength={15}
                ref={(e) => (inputRefs.current[inputIndex] = e)}
                defaultValue={inputRefs?.current[inputIndex]?.value}
                onChange={(e) => {
                  getInputLotteryId(inputIndex, e)
                }}
                onKeyDown={handleEnterKey(() => handleAddLotteryIdOnInput(lotto.index, inputIndex))}
                className="lottery-input" />
            </div>
          )
        })}
      </div>
      <hr />
    </NotFoundLotteryIDContent>
  )
}

export default NotFoundLotteryID

const NotFoundLotteryIDContent = styled.div`
  .lottery-header {
    display: flex;
    justify-content: space-between;
    margin: 1em 0 1em 0;

    .lottery-title {
      font-family: Prompt-SemiBold;
      line-height: 24px;
      font-size: 16px;
      flex: 1;
    }
    
    .remove-lottery-ids {
      flex: 1;
      font-size: 1em;
      font-weight: bold;
      padding: 0.25em 1em;
      border-radius: 3px;
      color: ${Colors.WHITE};
      border: 2px solid ${Colors.LIGHT_RED};
      background-color: ${Colors.LIGHT_RED};

      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }

      &:active {
        opacity: 0.8;
        color: ${Colors.SUPER_BLACK};
      }
    }
  }

  .lottery-content {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;

    .lottery-box {
      width: 24%;
      height: 24%;
      background-color: #fbfbfb;
      text-align: center;
      border-radius: 8px;
      border: 1px solid ${Colors.LIGHT_GREY2};

      .lottery-overlay-color {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .lottery-icon-box { 
          position: absolute;
          display: none;
          z-index: 1;
        }

        .lottery-overlay {
          display: none;
          border-radius: 8px;
          opacity: 0.5;
          width: 100%;
          height: 100%;
          position: absolute;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          background-color: ${Colors.SUPER_BLACK};
        }

        .lottery-image {
          width: 100%;
          border-radius: 8px;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        }
        
        &:hover {
          cursor: pointer;
      
          .lottery-overlay {
            display: block;
          }
          .lottery-icon-box {
            display: block;
          }
        }
      }

      .lottery-input {
        width: 95%;
        margin: 4px 0;
        font-size: 16px;
        font-weight: normal;

        &:hover {
          cursor: pointer;
          border: 1px solid blue;
        }
      }
    }
  }
`
